import React from 'react';
import { Section, SectionSubTitle } from 'common/components';
import { css } from 'linaria';

const newKitchenVideoSection = css`
  && {
    @media (--only-desktop) {
      margin-bottom: 80px;
    }
  }
`;

const newKitchenVideoItem = css`
  width: 100%;
  height: auto;
  border-radius: var(--rounding-m);
`;

export const NewKitchenVideo: React.FC = () => (
  <Section className={newKitchenVideoSection}>
    <SectionSubTitle margin="m">Делаем кухни по&nbsp;европейским стандартам</SectionSubTitle>
    <video
      className={newKitchenVideoItem}
      title="Делаем кухни по европейским стандартам"
      controls
      autoPlay
      muted>
      <source
        src="https://cdn.lemanapro.ru/lmru/image/upload/video/fudzi/mf-landings-web%252Fvideo%252FDelinia_ID.mp4/Delinia_ID.mp4"
        type="video/mp4"
      />
    </video>
  </Section>
);
